import { Flex } from '@chakra-ui/react';
import { memo, useCallback } from 'react';
import { ContentCard } from '~/components/ContentCard';
import { FEATURE_FLAGS } from '~/constants';
import { useFeature } from '~/hooks/useFeatureFlag/useFeature';
import { ContentCard as ContentCardWithMetrics } from '~/screens/PageBuilder/blocks/TalentContent/ContentCard/ContentCard';
import { ISearchContentResult } from '~/searchApi/content';

interface Props {
  contents: ISearchContentResult[];
  onClickItem?: (content: ISearchContentResult) => void;
}

export const SearchContentGrid: React.FC<Props> = memo(
  ({ contents, onClickItem }) => {
    const { isEnabled: isContentSearchMetrics } = useFeature(
      FEATURE_FLAGS.foamContentSearchMetrics,
    );

    const handleClick = useCallback(
      (content: ISearchContentResult) => onClickItem?.(content),
      [onClickItem],
    );

    if (isContentSearchMetrics) {
      return (
        <div className="flex w-full flex-wrap items-stretch gap-4 overflow-auto after:grow-[999] after:content-['']">
          {contents.map((content) => {
            return (
              <div key={content.contentId} className="relative grow">
                <ContentCardWithMetrics
                  key={content.contentId}
                  content={content}
                  onClick={handleClick}
                  showMetrics
                  interactive={false}
                />
              </div>
            );
          })}
        </div>
      );
    }

    return (
      <Flex
        flexWrap="wrap"
        gap={4}
        _after={{ content: '""', boxFlex: 999, flexGrow: 999 }}
      >
        {contents.map((content) => (
          <ContentCard
            key={content.contentId}
            contentData={content}
            onClick={handleClick}
          />
        ))}
      </Flex>
    );
  },
);
